import { hexToRgb, rgbDataURL } from 'corporate-utils';
import { getStrapiMedia } from '../../../utils/media';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import {
  CardContainer,
  CardImageStyled,
  CardTextWrapper,
  DescriptionWrapper,
  MainTitleWrapper,
  TitleWrapper,
} from './CardWorkshop.style';
import { getPersonalizationAllAttributes } from '../../../utils/style';
import { PersonalizationWorkshopCard } from '../../../models/auto-generated-strapi-types/types/components/PersonalizationWorkshopCard';
import { WorkshopNormalized } from '../../../utils/workshops';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';

interface CardWorkshopProps {
  data: WorkshopNormalized;
  personalization: PersonalizationWorkshopCard[];
  isPrerenderRequest: boolean;
}

const CardWorkshopComponent: React.FC<CardWorkshopProps> = ({
  data,
  personalization,
  isPrerenderRequest,
}) => {
  return (
    <CardContainer>
      <CardImageStyled>
        <ImageWithFallback
          layout="fill"
          objectFit="cover"
          placeholder="blur"
          blurDataURL={rgbDataURL(
            hexToRgb('ffffff')?.[0],
            hexToRgb('ffffff')?.[1],
            hexToRgb('ffffff')?.[2]
          )}
          src={getStrapiMedia(
            data?.attributes.thumbnail?.data?.attributes?.url
          )}
          alt={
            data?.attributes?.thumbnail.data?.attributes?.alternativeText || ''
          }
          fallbackSrc={DEFAULT_IMAGE}
          isPrerenderRequest={isPrerenderRequest}
        />
      </CardImageStyled>
      <CardTextWrapper>
        <MainTitleWrapper
          personalization={getPersonalizationAllAttributes(
            personalization,
            'mainTitle'
          )}
        >
          {data.attributes.category}
        </MainTitleWrapper>
        <TitleWrapper
          personalization={getPersonalizationAllAttributes(
            personalization,
            'title'
          )}
        >
          {data?.attributes.title}
        </TitleWrapper>
        <DescriptionWrapper
          personalization={getPersonalizationAllAttributes(
            personalization,
            'description'
          )}
        >
          {data?.attributes.description}
        </DescriptionWrapper>
      </CardTextWrapper>
    </CardContainer>
  );
};

export default CardWorkshopComponent;
